import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from './shared/guards/auth.guard';
// Using custom override - bar chart with pink/red color
import { BarChartComponent } from '@custom';
import { ChatComponent } from '@shared-lib/global-components/chat/chat.component';
import { AccessDeniedComponent } from './shared/components/access-denied/access-denied.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'Repower-Predictor',
    pathMatch: 'full',
  },
  {
    path: 'all-chart-1',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-1.json' },
  },

  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },

  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'dashboard-config.json' },
  },
  {
    path: 'Repower-Predictor',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'repower-predictor/repower-predictor.json' },
  },
  {
    path: 'repower-screen-2',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'repower-predictor/repower-screen-2.json' },
  },
  {
    path: 'repower-screen-3', component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'repower-predictor/repower-screen-3.json' },
  },
  {
    path: 'repower-screen-3-price-dynamics',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'repower-predictor/repower-screen-3-price-dynamics.json' },
  },
  {
    path: 'repower-screen-3-price-dynamics-line',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'repower-predictor/repower-screen-3-price-dynamics-line.json' },
  },
  {
    path: 'catastrophic-failure',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'repower-predictor/catastrophic-failure.json' },
  },
  {
    path: 'mine-risk-donut',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'repower-predictor/mine-risk-donut.json' },
  },
  {
    path: 'disclaimer',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'repower-predictor/disclaimer.json' },
  },
  {
    path: 'opportunity-simulator', component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'opportunity-simulator-config.json' },
  },
  {
    path: 'opportunity-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'opportunity-overview-config.json' },
  },
  {
    path: 'europe-impact-report',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'europe-Impact-report.json' },
  },
  {
    path: 'sales-overview',
    component: BarChartComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'customer-overview',
    component: DashboardComponent,
    data: { configFile: 'customer-overview.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'cspec-bridge',
    component: DashboardComponent,
    data: { configFile: 'cspec-bridge.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'cspec-sales-bridge',
    component: DashboardComponent,
    data: { configFile: 'cspec-sales-bridge.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'financial-metrics',
    component: DashboardComponent,
    data: { configFile: 'financial-metrics-poc.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'detailed_view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu_sales_overview.json' },
  },
  {
    path: 'chat',
    component: ChatComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'chat-config/chat-config.json' },
  },
  {
    path: 'repower-donut-and-filter-chart',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'repower-predictor/repower-donut-and-filter-chart.json' },
  },
  {
    path: 'tco-score',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'repower-predictor/tco-score.json' },
  },
  {
    path: 'repower-second-horizontal-bar-chart',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'repower-predictor/repower-second-horizontal-bar-chart.json' },
  },
  {
    path: '**',
    redirectTo: 'Repower-Predictor',
  },
];
